import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import API from '../../../../api/api'
import { setTicketData } from '../../../../reducers/parkingReducer'

const ParkingPaymentSuccess = ({ ticketNumber, setTicketDataStore }) => {
  const { t } = useTranslation(['parking', 'common'])
  const navigate = useNavigate()

  useEffect(() => {
    ;(async () => {
      try {
        const resp = await API.getParkingTicket(ticketNumber)
        setTicketDataStore(resp.data)
      } catch (error) {
        console.error(error)
      }
    })()
  }, [ticketNumber])

  return (
    <React.Fragment>
      <div className="parking-info__section center darker">
        <div className="parking-info__section-title">{t('parking:paymentSuccess.title')}</div>
        <div>{t('parking:paymentSuccess.description')}</div>
      </div>
      <div className="parking-info__section-info-full-row center">
        <div>{t('parking:statusBadge.serviceCompleted.ticketNoHash')}</div>
        <div className="parking-info__section-title">{ticketNumber}</div>
      </div>
      <button
        className="button is-black"
        style={{ marginTop: '20px' }}
        onClick={() => navigate(`/parking/${ticketNumber}/summary`)}
      >
        {t('common:actions.back')}
      </button>
    </React.Fragment>
  )
}

ParkingPaymentSuccess.propTypes = {
  ticketNumber: PropTypes.string,
  setTicketDataStore: PropTypes.func,
}

export default connect(null, { setTicketDataStore: setTicketData })(ParkingPaymentSuccess)
